import React, { useState, useEffect } from 'react';
import { useFattyAcids } from './useFattyAcids';

export const FattyAcidSelector = ( {selectedCells, setSelectedCells} ) => {
  const realRange = Array.from({ length: 19 }, (_, i) => i + 10); // 10 to 28
  const imagRange = Array.from({ length: 9 }, (_, i) => i); // 0 to 8

  const toggleSelection = (real, imag) => {
    const cell = { cc: real, db: imag };
    setSelectedCells(prev => {
      const exists = prev.some(item => item.cc === real && item.db === imag);
      return exists
        ? prev.filter(item => !(item.cc === real && item.db === imag))
        : [...prev, cell];
    });
  };

  return (
    <div className="container my-4">
      {/* Table for Custom Selection */}
      <table className="table table-bordered table-sm compact-table text-center">
        <thead>
          <tr>
            <th>CC:DB</th>
            {imagRange.map(imag => (
              <th key={imag}>{imag}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {realRange.map(real => (
            <tr key={real}>
              <td><strong>{real}</strong></td>
              {imagRange.map(imag => {
                const isSelected = selectedCells.some(
                  cell => cell.cc === real && cell.db === imag
                );
                return (
                  <td
                    key={`${real}-${imag}`}
                    className={`text-center ${isSelected ? 'bg-success text-white' : ''}`}
                    onClick={() => toggleSelection(real, imag)}
                    style={{ cursor: 'pointer' }}
                  >
                    {isSelected ? '✔' : ' '}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
